import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import isAuthenticated from './middlewares/isAuthenticated';

Vue.use( VueRouter );

// Middlewares que estão presentes em todas as routes do software
const globalMiddlewares = [ 'isAuthenticated' ];

// load dos middlewares
const routeMiddlewares = { isAuthenticated };

/**
 * Resolve async components.
 *
 * @param  {Array} components
 * @return {Array}
 */
const resolveComponents = components => {
    return Promise.all( components.map( component => {
        return typeof component === 'function' ? component() : component;
    }) );
};

/**
 * Obtém os middlewares e junta aos componentes.
 *
 * @param  {Array} components
 * @return {Array}
 */
const getMiddleware = components => {
    const middleware = [ ...globalMiddlewares ];

    components.filter( c => c.middleware ).forEach( component => {
        ( Array.isArray( component.middleware ) )
            ? middleware.push( ...component.middleware )
            : middleware.push( component.middleware );
    });

    return middleware;
};

/**
 * Obtém todos middlewares existentes.
 *
 * @param {Array} middleware
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
const callMiddleware = ( middleware, to, from, next ) => {
    const stack = middleware.reverse();

    // eslint-disable-next-line
    const $next = ( ...args ) => {
        // Stop if "$next" was called with an argument or the stack is empty.
        if ( args.length > 0 || stack.length === 0 )
            return next( ...args );

        const $middleware = stack.pop();

        if ( typeof middleware === 'function' )
            middleware( to, from, $next );
        else if ( routeMiddlewares[$middleware] )
            routeMiddlewares[$middleware]( to, from, $next );
        else
            throw Error( `Undefined middleware [${$middleware}]` );
    };

    $next();
};

/**
 *
 * Guarda global de rotas
 * Executa as validações dos middlewares.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
*/
// eslint-disable-next-line
const beforeEach = async ( to, from, next ) => {
    // Get the matched components and resolve them.
    const components = await resolveComponents(
        router.getMatchedComponents({ ...to })
    );

    if ( components.length === 0 )
        return next();

    // Get the middleware for all the matched components.
    const middleware = getMiddleware( components );

    // Call each middleware.
    callMiddleware( middleware, to, from, ( ...args ) => {
        // Set the application layout only if "next()" was called with no args.
        next( ...args );
    });
};

/**
 *
 * Cria uma nova instancia de router
 *
 * @return {Router}
*/
const createRouter = () => {
    const router = new VueRouter({
        mode: 'history',
        routes
    });

    router.beforeEach( beforeEach );

    return router;
};

const router = createRouter();

export default router;